import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import HeadTittle from '../../../components/HeadTittle';
import routes from '../../../Routes/routes';
import ButtonAction from '../../../components/buttons/ButtonAction';
import {EditIcon, MobileIcon, TrashOutlineIcon} from '../../../components/buttons/IconButtons';
import EmployeeDetailsBody from "./EmployeeDetailsBody";

const EmployeContractDetail = () => {
    const { t } = useTranslation();
    const [unlinkShow, setUnlinkShow] = useState(false);
    const [deleteEmployeeShow, setDeleteEmployeeShow] = useState(false);
    // use Selector
    const {getContractorEmployeeDetail} = useSelector((state) => state?.ContractorSlice);

    return (
        <>
            <HeadTittle name={t('complete_documents') }
                        link={routes.contractor.searchEmployee}
            >
                <ButtonAction
                    id='btn_ecd_unlink_device'
                    name='unlink_device'
                    className='btn-icon-delete'
                    Icon={MobileIcon}
                    splitName={false}
                    onClick={()=>{
                        setUnlinkShow(true);
                    }}
                    disabled={!getContractorEmployeeDetail?.user?.deviceId}
                />
                <ButtonAction
                    id='btn_ecd_update'
                    name='update'
                    Icon={EditIcon}
                    className='btn-icon-edit'
                    url={`${routes.contractor.updateEmployee}${getContractorEmployeeDetail?.user?.id}`}
                />
                <ButtonAction
                    id='btn_ecd_delete'
                    name='delete'
                    className='btn-icon-delete'
                    disabled={false}
                    Icon={TrashOutlineIcon}
                    onClick={()=>{
                        setDeleteEmployeeShow(true);
                    }}
                />
            </HeadTittle>
            <EmployeeDetailsBody
                disabled={false}
                deleteEmployeeShow={deleteEmployeeShow}
                setDeleteEmployeeShow={setDeleteEmployeeShow}
                unlinkShow={unlinkShow}
                setUnlinkShow={setUnlinkShow}
                showBtnDeleteDoc={true}
            />
        </>
    );
};

export default EmployeContractDetail;
